export default {
  verified: {
    id: 'product_page_verified',
    defaultMessage: 'Verified refurbished',
  },
  freeReturn: {
    id: 'product_reassurance_buttons_free_return',
    defaultMessage: '{day}-days free return',
  },
  labelLock: {
    id: 'product_page_carriers_lock',
    defaultMessage: 'Only compatible with',
  },
  workWithAllWrapper: {
    id: 'product_page_carriers_works_with_all',
    defaultMessage: 'Works with {text, html}',
  },
  workWithAllInner: {
    id: 'product_page_carriers_works_with_all_carriers',
    defaultMessage: 'all carriers',
  },
  freeShipping: {
    id: 'product_page_shipping_with_date',
    defaultMessage: 'Get it between {dates, html} free standard shipping',
  },
  freeShippingDates: {
    id: 'product_page_shipping_dates',
    defaultMessage: '{earliest} and {latest}',
  },
  expressShipping: {
    id: 'product_page_express_shipping',
    defaultMessage: 'Get it from {amount} between {earliest} and {latest}',
  },
}
